module.exports = ":host {\n  height: 100%;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/security/components/roles-tile.component.scss
// module id = ./src/app/security/components/roles-tile.component.scss
// module chunks = main